import globals from './globals.js';

function removeGroupSeparators(value, replaceDecimalSeparator) {
    replaceDecimalSeparator = replaceDecimalSeparator !== false;
    var returnValue = value.split(globals.intl.groupSeparator).join('');

    if (replaceDecimalSeparator) {
        return returnValue.split(globals.intl.decimalSeparator).join('.');
    }

    return returnValue;
}

function addGroupSeparator(newValue) {
    newValue = newValue === 0 ? '0' : newValue;

    if (!newValue) {
        return '';
    }

    return parseFloat(newValue).toLocaleString(globals.intl.locale);
}

export { removeGroupSeparators, addGroupSeparator };
